import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

// Solène Header — soft linen, sage accents. Brand center, nav split left/right.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 transition-all duration-700 ${scrolled ? 'bg-[#F2EBE0]/95 backdrop-blur-md border-b border-[#6F7E62]/20' : 'bg-[#F2EBE0]'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-4 grid grid-cols-[1fr_auto_1fr] items-center gap-8">
        {/* Left nav */}
        <nav className="hidden lg:flex items-center gap-8 justify-self-start">
          {ROUTES.slice(0, 2).map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`skin-nav-${r.id}`}
              className={`font-serif italic text-base transition-colors ${page === r.id ? 'text-[#B8654A]' : 'text-[#6F7E62]/85 hover:text-[#1B1A18]'}`}>
              <span dangerouslySetInnerHTML={{ __html: r.label }} />
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('home')} className="text-center" data-testid="skin-logo">
          <p className="font-serif italic text-3xl lg:text-4xl text-[#1B1A18]">{META.brand}</p>
          <p className="font-mono text-[8px] tracking-[0.4em] uppercase text-[#6F7E62] mt-1">{META.tagline}</p>
        </button>
        <nav className="hidden lg:flex items-center gap-8 justify-self-end">
          {ROUTES.slice(2).map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`skin-nav-${r.id}`}
              className={`font-serif italic text-base transition-colors ${page === r.id ? 'text-[#B8654A]' : 'text-[#6F7E62]/85 hover:text-[#1B1A18]'}`}>
              <span dangerouslySetInnerHTML={{ __html: r.label }} />
            </button>
          ))}
        </nav>
      </div>
      {/* Decorative botanical line */}
      <div className="border-t border-[#6F7E62]/20 hidden md:block">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 h-7 flex items-center justify-between font-mono text-[9px] tracking-[0.3em] uppercase text-[#6F7E62]/65">
          <span>— Maison de soins, Aix-en-Provence</span>
          <span>Carbon-neutral · Refillable · Organic</span>
        </div>
      </div>
    </header>
  );
}
